import { AnnotationComponentProps } from "@routes/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentSubscript({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <sub>{children}</sub>;
}
